var map = {
	"./album_a.png": 38737,
	"./album_b.png": 5329,
	"./album_c.png": 91957,
	"./album_d.png": 71942,
	"./album_e.png": 5680,
	"./album_f.png": 47254,
	"./album_g.png": 26998,
	"./album_h.png": 93706,
	"./album_i.png": 72347,
	"./album_j.png": 26214,
	"./photo_boot.png": 74723,
	"./stanford_logo.png": 67242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54691;